// Temporary script to remove subscription paragraph
document.addEventListener("DOMContentLoaded", () => {
  // Select all <p> elements inside the product__description container
  const paragraphs = document.querySelectorAll(".product__description p");
  paragraphs.forEach((paragraph) => {
    if (
      paragraph.textContent.trim() ===
      "Product offered as a one time purchase or monthly subscription with premium updates coming soon."
    ) {
      paragraph.remove(); // Remove the entire <p> element if the text matches
    }
  });
});

// 
document.addEventListener("DOMContentLoaded", function () {
  const links = ["#HeaderMenu-a11y-alt"];
  links.forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) {
      element.setAttribute("target", "_blank");
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    // Select all SVG elements inside .recurpay-pdp-widget
    const svgs = document.querySelectorAll(".recurpay-pdp-widget svg");

    // Add aria-hidden="true" to each SVG element
    svgs.forEach((svg) => {
      svg.setAttribute("aria-hidden", "true");
    });
  }, 2000);
});

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname.includes("/products")) {
    // Define the function once globally
    function generateUniqueId() {
      return `znt_${Math.random().toString(36).substr(2, 10)}`;
    }

    // First block of code
    setTimeout(() => {
      const widgetContainers = document.querySelectorAll(
        ".recurpay__widget_container"
      );
      widgetContainers.forEach((container) => {
        const subscribeRadio = container.querySelector('[type="radio"]');
        const groupHeader = container.querySelector(".recurpay__group_header");

        if (subscribeRadio && groupHeader) {
          const uniqueId = generateUniqueId();
          groupHeader.id = uniqueId;
          subscribeRadio.setAttribute("aria-labelledby", uniqueId);
        }
      });

      const frequencyGroups = document.querySelectorAll(
        ".recurpay__group_frequency"
      );
      frequencyGroups.forEach((group) => {
        const labelTitle = group.querySelector(
          ".recurpay__frequency_label_title"
        );
        const frequencySelect = group.querySelector(
          ".recurpay__frequency_select"
        );

        if (labelTitle && frequencySelect) {
          const uniqueId = generateUniqueId();
          labelTitle.id = uniqueId;
          frequencySelect.setAttribute("aria-labelledby", uniqueId);
        }
      });
    }, 2000);
  }


  // Check if the current page contains "/cart" in the path
  if (window.location.pathname.includes("/cart")) {
    // Function to generate unique IDs
    function generateUniqueId() {
      return `znt_${Math.random().toString(36).substr(2, 10)}`;
    }

    // Wait for potential DOM updates
    setTimeout(() => {
      // Select all dropdown wrappers on the cart page
      const dropdownWrappers = document.querySelectorAll(".cart-plan-dropdown-wrapper");

      dropdownWrappers.forEach((wrapper) => {
        const titleElement = wrapper.querySelector(".cart-plan-dropdown-title");
        const selectElement = wrapper.querySelector(".cart-plan-dropdown");

        // Ensure both elements exist before setting attributes
        if (titleElement && selectElement) {
          const uniqueId = generateUniqueId();
          titleElement.id = uniqueId;
          selectElement.setAttribute("aria-labelledby", uniqueId);
        }
      });
    }, 2000);
  }


});








// Check if element in footer has the year and replace it with the current year
document.addEventListener("DOMContentLoaded", function () {
    const copyrightElement = document.querySelector(".znt-shopify-footer_copyright");

    if (copyrightElement) {
        const currentYear = new Date().getFullYear(); // Get the current year
        copyrightElement.innerHTML = copyrightElement.innerHTML.replace(
            /\b\d{4}\b/g, // Match any 4-digit year
            `<span class="znt-footer_year">${currentYear}</span>`
        );
    }
});



